// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"66b4f9f9","453":"8701dc61","693":"d37a030f","958":"287b04e9"}[chunkId] + ".chunk.js";
};